import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/components/theme-provider';

// No existe en RISIT (sonner está en sus deps pero sin wrapper: no lo usa
// en ningún lado). Acá sí hace falta: es el canal de toasts globales de
// RedeApp. Sonner acepta theme "system" nativamente (sigue prefers-color-scheme
// por su cuenta), así que alcanza con pasarle el theme de nuestro
// ThemeProvider tal cual, sin resolverlo a mano.
//
// richColors: decisión de Juan 21/9/2026 (QA en vivo v0.15.2) — toast.error
// en rojo y toast.success en verde en toda la app. Sonner pinta esos dos
// (y warning/info, que acá no se usan) con su propia paleta —bg/border/text
// vía --success-*/--error-* — SOLO cuando el toast trae `data-rich-colors`;
// los `--normal-*` de abajo son variables aparte que solo tocan el toast
// neutro (los `toast(...)` sin método, ~7 casos: siguen con los tokens de
// RedeApp, no con blanco/negro de sonner) y el botón de `action` (que sonner
// siempre pinta invertido con --normal-bg/--normal-text, no con la paleta
// rica — por eso el "Deshacer" queda legible arriba de un toast verde o
// rojo sin tocar nada acá). Default `true`, pero queda como prop para no
// cerrarle la puerta a un caller que en algún punto necesite un Toaster sin
// esto (ninguno hoy).
function Toaster({ richColors = true, ...props }: ToasterProps) {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      richColors={richColors}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
